<template lang="html">
  <div class="opentracking">
  	<h1 v-html="$ml.get('opentracking.title')"/>
    <b-row class="mt-4">
      <b-col offset-md="1" md="10" sm="12" cols="12">
        <p class="card-text text-justify" v-for="i in $ml.get('opentracking.description')" :key="i" v-html="i"/>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="10" sm="12" offset-md="1" cols="12">
        <b-card-group deck>
          <b-card
            class="feature-card"
            align="center">
            <b-embed
              type="iframe"
              aspect="16by9"
              src="/static/vids/piattaforma_ot.mp4"
              allowfullscreen style="width:100%;left:0">
            </b-embed>
            <h4 class="mt-4 card-title" v-text="$ml.get('opentracking.card_1.title')"/>
            <b-card-text v-for="i in $ml.get('opentracking.card_1.text')" :key="i" v-html="i"/>
            <a class="read-more" href="#paragraph" @click="goToPar(1)"
            v-text="$ml.get('opentracking.read_more')"
            v-show="$ml.get('opentracking.card_1.read_more')"/>
          </b-card>
          <b-card
            class="feature-card"
            :title="$ml.get('opentracking.card_2.title')"
            img-src="static/img/shared/opentracking_logo.jpg"
            align="center">
            <b-card-text v-for="i in $ml.get('opentracking.card_2.text')" :key="i" v-html="i"/>
            <b-row>
              <b-col md="12">
                <b-img src="static/img/opentracking/frame.png" class="qr-code-img"/>
              </b-col>
            </b-row>
            <b-card-text v-text="$ml.get('opentracking.card_2.qrcode_text')" class="qr-code-p"/>
            <a href="https://play.google.com/store/apps/details?id=it.netlandsrl.opentracking"
            class="qr-code-a mb-4" target="_blank">
              {{ $ml.get('opentracking.card_2.qrcode_text') }}
            </a>
            <a class="read-more" href="#paragraph" @click="goToPar(2)"
            v-text="$ml.get('opentracking.read_more')"
            v-show="$ml.get('opentracking.card_2.read_more')"/>
          </b-card>
          <b-card
            class="feature-card"
            :title="$ml.get('opentracking.card_3.title')"
            img-src="static/img/opentracking/plugin.jpg"
            align="center">
            <b-card-text v-for="i in $ml.get('opentracking.card_3.text')" :key="i" v-html="i"/>
            <a class="read-more" href="#paragraph" @click="goToPar(3)"
            v-text="$ml.get('opentracking.read_more')"
            v-show="$ml.get('opentracking.card_3.read_more')"/>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-row class="mt-4 mb-4">
      <b-col offset-md="2" md="8" sm="12" cols="12">
        <hr>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col md="10" sm="12" offset-md="1" cols="12">
        <b-card-group deck>
          <b-card
            class="feature-card"
            :title="$ml.get('opentracking.card_4.title')"
            img-src="static/img/opentracking/qr_code2.jpg"
            align="center">
            <b-card-text v-for="i in $ml.get('opentracking.card_4.text')" :key="i" v-html="i"/>
            <a class="read-more" href="#paragraph" @click="goToPar(4)"
            v-text="$ml.get('opentracking.read_more')"
            v-show="$ml.get('opentracking.card_4.read_more')"/>
          </b-card>
          <b-card
            class="feature-card"
            :title="$ml.get('opentracking.card_5.title')"
            img-src="static/img/opentracking/pod_monitor.jpg"
            align="center">
            <b-card-text v-for="i in $ml.get('opentracking.card_5.text')" :key="i" v-html="i"/>
            <a class="read-more" href="#paragraph" @click="goToPar(5)"
            v-text="$ml.get('opentracking.read_more')"
            v-show="$ml.get('opentracking.card_5.read_more')"/>
          </b-card>
          <b-card
            class="feature-card"
            :title="$ml.get('opentracking.card_6.title')"
            img-src="static/img/opentracking/foto_riserva.jpg"
            align="center">
            <b-card-text v-for="i in $ml.get('opentracking.card_6.text')" :key="i" v-html="i"/>
            <a class="read-more" href="#paragraph" @click="goToPar(6)"
            v-text="$ml.get('opentracking.read_more')"
            v-show="$ml.get('opentracking.card_6.read_more')"/>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-row class="mt-4 mb-4">
      <b-col md="12" sm="12" cols="12">
        <hr>
      </b-col>
    </b-row>
    <b-row id="paragraph" v-if="par_id>0">
      <b-col offset-md="1" md="10" sm="12" cols="12">
        <b-card class="paragraph-card">
          <b-card-header class="tracking-bg mb-4" v-html="$ml.get('paragraph_title')"/>
          <b-card-text v-for="i in $ml.get('paragraph_text')" :key="i" v-html="i"/>
        </b-card>
      </b-col>
    </b-row>
    <b-button v-show="showGoTop" id="goTopBtn" @click="goTop()">Top</b-button>
  </div>
</template>

<script>
import { MLBuilder } from 'vue-multilanguage'
export default {
  data () {
    return {
      par_id: 0,
      showGoTop: false
    }
  },
  computed: {
    mlparagraph_title () {
      const p = 'opentracking.paragraph_' + this.par_id + '.title'
      return new MLBuilder(p)
    },
    mlparagraph_text () {
      const p = 'opentracking.paragraph_' + this.par_id + '.text'
      return new MLBuilder(p)
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll (event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400
    },
    goTop () {
      window.scroll({top: 0, behavior: 'smooth'})
    },
    goToPar (w) {
      this.par_id = w
      const el = document.querySelector('#paragraph')
      if (el) {
        window.scroll({top: el.offsetTop, behavior: 'smooth'})
      }
    },
    jumpTo (w) {
      this.$router.push(w)
    }
  }
}
</script>

<style lang="css" scoped>
.col-md-weird {
  width: 37.5%;
}

.touch-too-much {
  text-align: left;
}

div .features .card-deck {
  padding: 10px 55px;
}

.feature-card {
  -webkit-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  -moz-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  max-width: 30%;
  /*cursor: pointer;*/
}

.paragraph_card {
  -webkit-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  -moz-box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
  box-shadow: 0px 10px 30px 0px rgba(0,0,0,0.08);
}

@media only screen and (max-width: 1000px) {
  .feature-card {
    min-width: 100%;
    max-width: 100%;
  }
  .qr-code-img {
    display: none;
  }
  .qr-code-p {
    display: none;
  }

  .qr-code-a {
    text-align: center!important;
    display: block!important;
    color: #E0161A;
  }

  .qr-code-a:hover {
    color: #444;
    text-decoration: none!important;
  }
}

.card-text {
  text-align: left;
}

hr {
  -webkit-box-shadow: 0 20px 20px -20px #333;
  -moz-box-shadow: 0 20px 20px -20px #333;
  box-shadow: 0 20px 20px -20px #333;
}

.tracking-bg {
    background-color: rgba(8,152,222,1)!important;
    color: #FDFDFD;
}
.read-more {
  text-align: right;
  right: 0.7em;
  bottom: 0.4em;
  position: absolute;
  font-size: 0.8em;
}
.read-more:hover {
  text-decoration: none;
}

.text-justify, .card-text {
  text-align: justify!important;
}

.red-button {
  background-color: #E0161A;
  color: #FDFDFD;
  border: none;
  outline: none;
  padding: .4rem 1.3rem;
}

.red-button:hover {
  background-color: #444;
}

.qr-code-img {
  margin: auto;
  max-width: 100%;
}

.qr-code-p {
  text-align: center!important;
}

.qr-code-a {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/OpenTracking.vue